import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {readEndpoint} from 'redux-json-api'
import {List} from 'immutable'

import HorizontalList from './HorizontalList'
import RemoveFirmUser from '../shared_firm/RemoveFirmUser'
import ShadowWrapper from './ShadowWrapper'
import UserSubpage from './UserSubpage'
import SessionStore from '../../../../auth/src/stores/SessionStore'
import SendFirmUserInvite from './SendFirmUserInvite'
import UserInformation from './UserInformation'
import {isFuneralHome} from '../../lib/firmTools'

import {
  filterRawResourceByAttributeId,
  findRawResourceById
} from '../../../../lib/plan_data/userData'

import './accountInfo.scss'

export class AccountInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentUser: SessionStore.getState().currentUser,
      firmSeats: List()
    }
    this.fetchFirmSeats = this.fetchFirmSeats.bind(this)
  }

  componentDidMount() {
    this.fetchFirmSeats()
  }

  fetchFirmSeats() {
    const firmId = this.props.params.firmId

    if (!firmId)
      return

    this.props.readEndpoint(`firms/${firmId}?include=firm-seats`).then(response => {
      const firmSeats = response.body.included.filter(seat => seat.type === 'firm-seats')
      const filteredFirmSeats = filterRawResourceByAttributeId({
        attribute: 'firm-id',
        rawResource: {data: firmSeats},
        id: firmId
      })


      this.setState({firmSeats: filteredFirmSeats || List()})
    })
  }

  render() {
    const userData = this.props.user.data

    const hasClients = (userData.client_seats.active + userData.client_seats.draft + userData.client_seats.pending > 0)
    const isActive = (userData.status === 'active')
    return (
      <UserSubpage className='account-info' headerText='Account Info'>
        <ShadowWrapper className='column-wrapper-sb'>
          <StatusRow
            firstName={userData.first_name}
            isActive={isActive}
            seats={userData.client_seats}
            status={userData.status}
            type={userData.type}
            params={this.props.params}
          />
          <UserInformation
            {...userData}
            accountManager={this.state.currentUser.account_manager}
            firmConfig={this.props.firmConfig}
            params={this.props.params}
          />
          <RemoveFirmUser
            userSeatId={this.props.params.firmUserSeatId}
            user={userData}
            firmId={this.props.params.firmId}
            firmConfig={this.props.firmConfig}
            isActive={isActive}
            hasClients={hasClients}
            firmSeats={this.state.firmSeats}
            fetchFirmSeats={this.fetchFirmSeats}
            isFuneralHome={this.props.isFuneralHome}
          />
        </ShadowWrapper>
      </UserSubpage>
    )
  }
}

AccountInfo.defaultProps = {
  user: {
    data: {},
    errors: [],
    message: null
  },
  firmSeats: List()
}

AccountInfo.propTypes = {
  firmConfig: PropTypes.object,
  firmSeats: PropTypes.instanceOf(List),
  isFuneralHome: PropTypes.bool,
  params: PropTypes.shape({
    firmId: PropTypes.string.isRequired,
    firmUserSeatId: PropTypes.string.isRequired
  }).isRequired,
  readEndpoint: PropTypes.func.isRequired,
  user: PropTypes.shape({
    data: PropTypes.shape({
      email: PropTypes.string,
      first_name: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.oneOf(['active', 'draft', 'pending']),
      type: PropTypes.oneOf(['AdvisorSeat', 'AssistantSeat']),
      external_id: PropTypes.string,
      client_seats: PropTypes.shape({
        active: PropTypes.number,
        draft: PropTypes.number,
        pending: PropTypes.number
      })
    }),
    errors: PropTypes.arrayOf(PropTypes.string),
    message: PropTypes.string
  }).isRequired
}


const StatusMessage = props => {
  switch (props.status) {
    case 'active':
      return (<span className='status'><strong>ACTIVE</strong></span>)
    case 'pending':
      return (<span className='status'><strong>PENDING</strong> - Invitation sent but not yet accepted.</span>)
    case 'draft':
      return (<span className='status'><strong>DRAFT</strong> - Invitation hasn't been sent yet.</span>)
    default:
      break
  }
}

StatusMessage.propTypes = {
  status: PropTypes.oneOf(['active', 'draft', 'pending']).isRequired
}


const ButtonOrStats = props => {
  switch (props.status) {
    case 'active':
      if (props.type === 'AdvisorSeat') {
        return (
          <HorizontalList className='seat-data'>
            <span>{props.seats.active} {`client${props.seats.active === 1 ? '' : 's'}`} active</span>
            <span>{props.seats.pending} invited</span>
            <span>{props.seats.draft} draft</span>
          </HorizontalList>
        )
      }

      return <span />
    case 'pending':
    case 'draft':
      return (<SendFirmUserInvite firstName={props.firstName} params={props.params} status={props.status} />)
    default:
      break
  }
}

ButtonOrStats.propTypes = {
  firstName: PropTypes.string.isRequired,
  params: PropTypes.shape({
    firmId: PropTypes.string,
    firmUserSeatId: PropTypes.string
  }),
  seats: PropTypes.shape({
    active: PropTypes.number,
    draft: PropTypes.number,
    pending: PropTypes.number
  }).isRequired,
  status: PropTypes.oneOf(['active', 'draft', 'pending']).isRequired,
  type: PropTypes.oneOf(['AdvisorSeat', 'AssistantSeat']).isRequired
}


const StatusRow = props => (
  <div className='row-wrapper'>
    <div>Status:</div>
    <div className={classnames('column-wrapper-sb', {'active-advisor': props.isActive && props.type === 'AdvisorSeat'})}>
      <StatusMessage status={props.status} />
      <ButtonOrStats firstName={props.firstName} seats={props.seats} status={props.status} type={props.type} params={props.params} />
    </div>
  </div>
)

StatusRow.propTypes = {
  firstName: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    firmId: PropTypes.string,
    firmUserSeatId: PropTypes.string
  }),
  seats: PropTypes.shape({
    active: PropTypes.number,
    draft: PropTypes.number,
    pending: PropTypes.number
  }).isRequired,
  status: PropTypes.oneOf(['active', 'draft', 'pending']).isRequired,
  type: PropTypes.oneOf(['AdvisorSeat', 'AssistantSeat']).isRequired
}

const mapStateToProps = ({api}, ownProps) => ({
  isFuneralHome: isFuneralHome(
    findRawResourceById({rawResource: api.firms, id: ownProps.params.firmId})
  )
})

export default connect(mapStateToProps, {readEndpoint})(AccountInfo)
